import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79d3fb08")

_pushScopeId("data-v-79d3fb08")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Magazzino")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "commesse_modale" }
const _hoisted_5 = { class: "commesse_container" }
const _hoisted_6 = {
  key: 0,
  class: "searched_result_list"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "searched_result_list no_result"
}
const _hoisted_9 = { class: "container_movimenti" }
const _hoisted_10 = { class: "card_movimento" }
const _hoisted_11 = { class: "container_barcode" }
const _hoisted_12 = { class: "select_container" }
const _hoisted_13 = { class: "first_row" }
const _hoisted_14 = { class: "half_width" }
const _hoisted_15 = { class: "half_width" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "commessa_selection_container" }
const _hoisted_18 = { class: "first_row" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "selection_title" }, "Commessa", -1)
const _hoisted_20 = {
  key: 0,
  class: "second_row"
}
const _hoisted_21 = { style: {"margin":"4px"} }
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "second_row help_text"
}
const _hoisted_24 = {
  key: 0,
  class: "container_product"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "last_barcode" }, "Articoli aggiunti", -1)
const _hoisted_26 = { class: "product_info" }
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = { class: "product_quantity" }
const _hoisted_29 = { class: "container_azioni" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_SelectMagazzino = _resolveComponent("SelectMagazzino")
  const _component_BarcodeCustom = _resolveComponent("BarcodeCustom")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadMagazzini()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_Transition, { name: "fade-transition" }, {
                  default: _withId(() => [
                    _withDirectives(_createVNode("div", _hoisted_4, [
                      _createVNode("div", _hoisted_5, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          placeholder: "Cerca commessa",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.searchQueryCommessa = $event)),
                          class: "search_query_input"
                        }, null, 512), [
                          [_vModelText, $setup.searchQueryCommessa]
                        ]),
                        ($setup.filteredCommesse.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_6, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.filteredCommesse, (commessa) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: commessa.projects_id,
                                  onClick: ($event: any) => ($setup.setSelectedCommessa(commessa)),
                                  class: ["commessa", { 'selected_commessa': $setup.isSelectedCommessa(commessa) }]
                                }, [
                                  _createTextVNode(_toDisplayString(commessa.projects_name), 1),
                                  _hoisted_7,
                                  _createVNode("small", null, _toDisplayString(commessa.customers_full_name), 1)
                                ], 10, ["onClick"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_8, " Nessuna commessa trovata "))
                      ]),
                      _createVNode("div", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.closeCommessaSelection())),
                        class: "close_modal"
                      }, "Chiudi")
                    ], 512), [
                      [_vShow, $setup.isCommessaSelectionOpen]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, [
                        _createVNode("div", _hoisted_13, [
                          _createVNode("div", _hoisted_14, [
                            _createVNode(_component_SelectMagazzino, {
                              title: "Magazzino",
                              items: $setup.magazzini,
                              selected: $setup.selectedMagazzino,
                              onChange: $setup.setSelectedMagazzino,
                              placeholder: "Seleziona magazzino"
                            }, null, 8, ["items", "selected", "onChange"])
                          ]),
                          _createVNode("div", _hoisted_15, [
                            _createVNode(_component_SelectMagazzino, {
                              title: "Tipo movimento",
                              items: $setup.tipi_movimenti,
                              selected: $setup.selectedMovimento,
                              onChange: $setup.setSelectedMovimento,
                              placeholder: "Seleziona movimento"
                            }, null, 8, ["items", "selected", "onChange"])
                          ])
                        ]),
                        ($setup.showCausale)
                          ? (_openBlock(), _createBlock(_component_SelectMagazzino, {
                              key: 0,
                              title: "Causale",
                              items: $setup.causali,
                              selected: $setup.selectedCausale,
                              onChange: $setup.setSelectedCausale,
                              placeholder: "Seleziona causale"
                            }, null, 8, ["items", "selected", "onChange"]))
                          : _createCommentVNode("", true),
                        ($setup.activeGiroMagazzino)
                          ? (_openBlock(), _createBlock("div", _hoisted_16, [
                              _createVNode(_component_SelectMagazzino, {
                                title: "Magazzino ricevente",
                                items: $setup.magazzini,
                                selected: $setup.selectedMagazzinoRicevente,
                                onChange: $setup.setSelectedMagazzinoRicevente,
                                placeholder: "Seleziona magazzino"
                              }, null, 8, ["items", "selected", "onChange"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_17, [
                          _createVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createVNode("span", {
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.openCommessaSelection && $setup.openCommessaSelection(...args)))
                            }, "Seleziona")
                          ]),
                          ($setup.currentCommessa)
                            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                _createVNode("p", _hoisted_21, [
                                  _createTextVNode(_toDisplayString($setup.currentCommessa.projects_name) + " ", 1),
                                  _hoisted_22,
                                  _createVNode("small", null, _toDisplayString($setup.currentCommessa.customers_full_name), 1)
                                ])
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_23, " Seleziona una commessa da associare al movimento "))
                        ])
                      ]),
                      _createVNode(_component_BarcodeCustom, {
                        ref: "scannerRef",
                        onDecode: $setup.onDecode,
                        onLoaded: $setup.onLoaded,
                        style: {"width":"100%"}
                      }, null, 8, ["onDecode", "onLoaded"]),
                      ($setup.products && $setup.products.length != 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_24, [
                            _hoisted_25,
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.products, (prod, index) => {
                              return (_openBlock(), _createBlock("div", {
                                key: index,
                                class: "single_product"
                              }, [
                                _createVNode("div", _hoisted_26, [
                                  _createVNode("div", null, [
                                    _createTextVNode(_toDisplayString($setup.truncateText(prod.name, 30)) + " ", 1),
                                    _hoisted_27,
                                    _createVNode("small", null, _toDisplayString(prod.barcode), 1)
                                  ]),
                                  _createVNode("div", _hoisted_28, [
                                    _createVNode("span", {
                                      onClick: ($event: any) => ($setup.decreaseQuantity(index))
                                    }, "-", 8, ["onClick"]),
                                    _withDirectives(_createVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ($setup.products[index].quantity = $event),
                                      onInput: ($event: any) => ($setup.updateQuantity(index)),
                                      min: "1",
                                      class: "quantity_input"
                                    }, null, 40, ["onUpdate:modelValue", "onInput"]), [
                                      [
                                        _vModelText,
                                        $setup.products[index].quantity,
                                        void 0,
                                        { number: true }
                                      ]
                                    ]),
                                    _createVNode("span", {
                                      onClick: ($event: any) => ($setup.addQuantity(index))
                                    }, "+", 8, ["onClick"])
                                  ])
                                ]),
                                _createVNode("div", null, [
                                  _createVNode("button", {
                                    onClick: ($event: any) => ($setup.removeProduct(index)),
                                    class: "btn_remove_product"
                                  }, "X", 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_29, [
                      _createVNode("button", {
                        class: "nuovo_movimento_button",
                        style: {"margin-top":"24px"},
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.creaMovimento && $setup.creaMovimento(...args))),
                        disabled: $setup.disableNewMovimento
                      }, " Crea movimento ", 8, ["disabled"])
                    ])
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})